var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VillagesTopNav',{on:{"leftIconFun":function (){this$1.$router.go(-1);}}},[_c('h2',{attrs:{"slot":"content"},slot:"content"},[_vm._v("我的帖子")])]),_c('div',{staticClass:"my-comment"},[_vm._l((_vm.newsData),function(item){return [_c('myPost',{attrs:{"data":item}})]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }